var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 41,
    viewBox: "0 0 136 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2494_47146)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.358 40.5H5.36121C2.60449 40.5 0.359375 38.2456 0.359375 35.5V5.5C0.359375 2.74439 2.60449 0.5 5.36121 0.5H130.358C133.112 0.5 135.359 2.74439 135.359 5.5V35.5C135.359 38.2456 133.112 40.5 130.358 40.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.358 1.3005C132.67 1.3005 134.562 3.18828 134.562 5.5V35.5C134.562 37.8117 132.682 39.6995 130.358 39.6995H5.36121C3.04904 39.6995 1.15659 37.8117 1.15659 35.5V5.5C1.15659 3.18828 3.03663 1.3005 5.36121 1.3005H130.358ZM130.358 0.5H5.36121C2.60449 0.5 0.359375 2.75436 0.359375 5.5V35.5C0.359375 38.2556 2.60449 40.5 5.36121 40.5H130.358C133.112 40.5 135.359 38.2556 135.359 35.5V5.5C135.359 2.75436 133.112 0.5 130.358 0.5Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4785 13.732C70.577 13.732 69.817 13.4153 69.216 12.7918C68.62 12.1858 68.2872 11.3504 68.3021 10.4975C68.3021 9.58732 68.6101 8.81675 69.216 8.20577C69.8146 7.58233 70.5745 7.26562 71.476 7.26562C72.3676 7.26562 73.1276 7.58233 73.7385 8.20577C74.3445 8.8367 74.6525 9.60727 74.6525 10.4975C74.6425 11.4103 74.3346 12.1808 73.7385 12.7893C73.14 13.4177 72.38 13.732 71.4785 13.732ZM44.654 13.732C43.7724 13.732 43.0074 13.4202 42.3816 12.8043C41.7607 12.1908 41.4453 11.4153 41.4453 10.5C41.4453 9.58483 41.7607 8.80927 42.3816 8.1958C42.995 7.57984 43.76 7.26812 44.654 7.26812C45.0911 7.26812 45.5158 7.3554 45.9231 7.53246C46.3229 7.70453 46.6483 7.93894 46.8892 8.22572L46.9488 8.29804L46.2758 8.96139L46.2062 8.87909C45.8262 8.42523 45.3171 8.20328 44.6441 8.20328C44.0431 8.20328 43.5191 8.41774 43.0869 8.84169C42.6523 9.26812 42.4313 9.82672 42.4313 10.5025C42.4313 11.1783 42.6523 11.7369 43.0869 12.1634C43.5191 12.5873 44.0431 12.8018 44.6441 12.8018C45.2848 12.8018 45.8238 12.5873 46.2435 12.1634C46.4918 11.914 46.6458 11.5649 46.7004 11.1235H44.5423V10.1908H47.6268L47.6392 10.2756C47.6616 10.4327 47.6839 10.5948 47.6839 10.7444C47.6839 11.6048 47.4256 12.3005 46.914 12.8143C46.3329 13.4227 45.5729 13.732 44.654 13.732ZM80.3199 13.5998H79.3687L76.4555 8.91899L76.4803 9.76188V13.5973H75.5291V7.40029H76.6144L76.6442 7.44767L79.3836 11.8566L79.3587 11.0162V7.40029H80.3199V13.5998ZM64.3309 13.5998H63.3673V8.33296H61.6959V7.40029H65.9999V8.33296H64.3285V13.5998H64.3309ZM60.9111 13.5998H59.95V7.40029H60.9111V13.5998ZM55.5095 13.5998H54.5484V8.33296H52.877V7.40029H57.1809V8.33296H55.5095V13.5998ZM52.2685 13.5898H48.5829V7.40029H52.2685V8.33296H49.5466V10.0337H52.0028V10.9564H49.5466V12.6571H52.2685V13.5898ZM69.9213 12.1509C70.351 12.5823 70.8725 12.7993 71.4785 12.7993C72.1019 12.7993 72.611 12.5873 73.0357 12.1509C73.4579 11.727 73.6715 11.1709 73.6715 10.5C73.6715 9.82922 73.4579 9.27061 73.0382 8.84917C72.6085 8.41774 72.0845 8.20079 71.481 8.20079C70.8576 8.20079 70.3485 8.41276 69.9263 8.84917C69.5041 9.27311 69.2905 9.82922 69.2905 10.5C69.2905 11.1709 69.5016 11.7295 69.9213 12.1509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2102 22.2554C65.8633 22.2554 63.9609 24.0434 63.9609 26.5098C63.9609 28.9537 65.8757 30.7641 68.2102 30.7641C70.5572 30.7641 72.4596 28.9636 72.4596 26.5098C72.4596 24.0434 70.5572 22.2554 68.2102 22.2554ZM68.2102 29.0784C66.9262 29.0784 65.8211 28.011 65.8211 26.4998C65.8211 24.9661 66.9287 23.9213 68.2102 23.9213C69.4942 23.9213 70.5994 24.9661 70.5994 26.4998C70.6019 28.021 69.4942 29.0784 68.2102 29.0784ZM58.9392 22.2554C56.5922 22.2554 54.6898 24.0434 54.6898 26.5098C54.6898 28.9537 56.6047 30.7641 58.9392 30.7641C61.2861 30.7641 63.1885 28.9636 63.1885 26.5098C63.1885 24.0434 61.2836 22.2554 58.9392 22.2554ZM58.9392 29.0784C57.6552 29.0784 56.55 28.011 56.55 26.4998C56.55 24.9661 57.6577 23.9213 58.9392 23.9213C60.2232 23.9213 61.3283 24.9661 61.3283 26.4998C61.3283 28.021 60.2232 29.0784 58.9392 29.0784ZM47.9073 23.5547V25.3552H52.2113C52.0796 26.3651 51.7469 27.1108 51.2377 27.622C50.6069 28.2554 49.6334 28.9437 47.9172 28.9437C45.2723 28.9437 43.2035 26.7991 43.2035 24.1432C43.2035 21.4873 45.2723 19.3427 47.9172 19.3427C49.3453 19.3427 50.3859 19.9088 51.1583 20.632L52.4298 19.3552C51.3569 18.3227 49.9289 17.5322 47.9272 17.5322C44.2987 17.5322 41.2539 20.4998 41.2539 24.1332C41.2539 27.7766 44.2962 30.7342 47.9272 30.7342C49.8867 30.7342 51.3569 30.0908 52.5192 28.8789C53.7039 27.6893 54.0789 26.011 54.0789 24.6569C54.0789 24.2355 54.0466 23.8564 53.9796 23.5347H47.9048C47.9073 23.5322 47.9073 23.5547 47.9073 23.5547ZM93.0307 24.9562C92.6756 24.0011 91.6027 22.2454 89.4023 22.2454C87.2217 22.2454 85.4087 23.9686 85.4087 26.4998C85.4087 28.8888 87.2018 30.7542 89.6134 30.7542C91.5505 30.7542 92.6781 29.5646 93.1425 28.8664L91.7045 27.8988C91.2277 28.6095 90.5646 29.0759 89.6233 29.0759C88.6721 29.0759 88.0065 28.642 87.5644 27.7866L93.2294 25.43C93.2294 25.4325 93.0307 24.9562 93.0307 24.9562ZM87.254 26.3776C87.2093 24.7342 88.5256 23.8988 89.4668 23.8988C90.2094 23.8988 90.8278 24.2654 91.0389 24.7991L87.254 26.3776ZM82.652 30.4998H84.5122V18.0011H82.652V30.4998ZM79.5973 23.2006H79.5302C79.1105 22.6993 78.3133 22.2454 77.295 22.2454C75.1815 22.2454 73.2344 24.1133 73.2344 26.5123C73.2344 28.9013 75.1716 30.7467 77.295 30.7467C78.3008 30.7467 79.1105 30.2903 79.5302 29.7791H79.5973V30.3901C79.5973 32.0135 78.733 32.8888 77.3397 32.8888C76.1998 32.8888 75.492 32.0659 75.2039 31.3776L73.5871 32.0559C74.0515 33.1781 75.2908 34.5671 77.3372 34.5671C79.5178 34.5671 81.3655 33.2779 81.3655 30.1332V22.4998H79.6072V23.2006C79.6097 23.2006 79.5973 23.2006 79.5973 23.2006ZM77.4614 29.0784C76.1774 29.0784 75.1045 28.0011 75.1045 26.5123C75.1045 25.011 76.1774 23.9237 77.4614 23.9237C78.733 23.9237 79.7189 25.0235 79.7189 26.5123C79.7314 28.0011 78.7355 29.0784 77.4614 29.0784ZM101.74 18.0011H97.2925V30.4998H99.1526V25.7666H101.743C103.802 25.7666 105.826 24.2679 105.826 21.8888C105.826 19.5098 103.809 18.0011 101.74 18.0011ZM101.795 24.021H99.1502V19.7317H101.795C103.188 19.7317 103.976 20.8863 103.976 21.8764C103.976 22.8564 103.178 24.021 101.795 24.021ZM113.281 22.233C111.93 22.233 110.537 22.834 109.961 24.1432L111.61 24.8315C111.965 24.1432 112.616 23.9088 113.304 23.9088C114.267 23.9088 115.241 24.4873 115.263 25.5198V25.6519C114.931 25.4624 114.2 25.1731 113.326 25.1731C111.546 25.1731 109.74 26.1507 109.74 27.9836C109.74 29.6619 111.2 30.7392 112.827 30.7392C114.076 30.7392 114.764 30.1731 115.194 29.5173H115.261V30.4848H117.054V25.6968C117.054 23.4674 115.405 22.233 113.281 22.233ZM113.048 29.0784C112.44 29.0784 111.588 28.7791 111.588 28.011C111.588 27.0434 112.651 26.6769 113.557 26.6769C114.377 26.6769 114.764 26.8539 115.251 27.0983C115.117 28.2205 114.173 29.0684 113.048 29.0784ZM123.596 22.4998L121.46 27.9213H121.393L119.18 22.4998H117.178L120.499 30.0784L118.606 34.2903H120.543L125.652 22.4998H123.596ZM106.852 30.4998H108.712V18.0011H106.852V30.4998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7514 8.03315C10.4633 8.34487 10.2969 8.82118 10.2969 9.44462V31.5568C10.2969 32.1803 10.4633 32.6566 10.7613 32.9558L10.8383 33.0232L23.1765 20.6342V20.3573L10.8284 7.96582L10.7514 8.03315Z",
    fill: "url(#paint0_linear_2494_47146)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2793 24.7772L23.1641 20.6451V20.3558L27.2793 16.2236L27.3687 16.2785L32.2365 19.0566C33.6297 19.8446 33.6297 21.1463 32.2365 21.9443L27.3687 24.7224L27.2793 24.7772Z",
    fill: "url(#paint1_linear_2494_47146)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3698 24.7219L23.1652 20.5L10.75 32.9663C11.2045 33.4551 11.9669 33.51 12.8188 33.0337L27.3698 24.7219Z",
    fill: "url(#paint2_linear_2494_47146)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3698 16.2784L12.8188 7.97918C11.9669 7.4904 11.202 7.55774 10.75 8.04651L23.1652 20.5004L27.3698 16.2784Z",
    fill: "url(#paint3_linear_2494_47146)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2823 24.6318L12.8305 32.8762C12.0234 33.3425 11.3031 33.3101 10.8387 32.8862L10.7617 32.9635L10.8387 33.0308C11.3031 33.4523 12.0234 33.4872 12.8305 33.0208L27.3816 24.7216L27.2823 24.6318Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2391 21.7993L27.2695 24.6322L27.3589 24.7219L32.2267 21.9439C32.9245 21.5449 33.2673 21.0212 33.2673 20.5C33.225 20.9788 32.8699 21.4327 32.2391 21.7993Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8201 8.12329L32.2389 19.2006C32.8697 19.5572 33.2249 20.0235 33.2795 20.4999C33.2795 19.9787 32.9368 19.455 32.2389 19.056L12.8201 7.97866C11.4269 7.17816 10.2969 7.84649 10.2969 9.44499V9.58963C10.2969 7.98863 11.4269 7.33277 12.8201 8.12329Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2494_47146",
    x1: 22.0698,
    y1: 9.20606,
    x2: 2.29537,
    y2: 14.4534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2494_47146",
    x1: 34.0534,
    y1: 20.5005,
    x2: 9.95568,
    y2: 20.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2494_47146",
    x1: 25.0835,
    y1: 22.7973,
    x2: 9.12073,
    y2: 49.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2494_47146",
    x1: 7.62372,
    y1: 0.679171,
    x2: 14.7454,
    y2: 12.6291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2494_47146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    fill: "white",
    transform: "translate(0.359375 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIcon);
export default __webpack_public_path__ + "static/media/playStoreIcon.da87505ceeceffae3ba97762e465ddab.svg";
export { ForwardRef as ReactComponent };